import type { AxiosRequestConfig } from 'axios';
import { useMutation } from '@tanstack/react-query';
import uuid from 'react-native-uuid';
import { ApiLogger } from 'fmc-digital-common';

const useTriggerMfa = () => {
    const correlationId = uuid.v4().toString();
    return useMutation({
        mutationFn: async ({ mfaId, mobileNumber, resend, triggerMfaUrl, authToken, xApiKey, logApiEvent }: any) => {
            const webRequestBody = {
                mfaId: mfaId,
                phoneNumber: mobileNumber,
                resend: resend
            };

            const config: AxiosRequestConfig = {
                method: 'post',
                url: triggerMfaUrl,
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'x-correlation-id': correlationId,
                    'x-api-key': `${xApiKey}`
                },
                data: webRequestBody
            };
            return await ApiLogger(config, logApiEvent);
        }
    });
};

export { useTriggerMfa };
